import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Image, DollarSign, Clock, Palette, Sparkles, Gift } from 'lucide-react';
const features = [{
  icon: BookOpen,
  title: '40 ideias prontas e testadas',
  description: 'Divididas por estilo: rústico, romântico, minimalista, moderno, clássico e boho.',
  isBonus: false
}, {
  icon: Image,
  title: 'Fotos de referência',
  description: "Veja exatamente como fica pronto. Sem surpresas, sem 'achismos'.",
  isBonus: false
}, {
  icon: DollarSign,
  title: 'Lista de materiais e custos',
  description: 'Saiba quanto vai gastar por unidade antes de comprar qualquer coisa.',
  isBonus: true
}, {
  icon: Clock,
  title: 'Passo a passo simples',
  description: 'Sem técnicas complicadas. Instruções claras que qualquer pessoa consegue seguir.',
  isBonus: false
}, {
  icon: Palette,
  title: 'Variações para temas',
  description: 'Adapte cada ideia para o seu tema específico. Cores, estilos e acabamentos.',
  isBonus: false
}, {
  icon: Sparkles,
  title: 'Truques do Efeito Boutique™',
  description: 'Os segredos usados em casamentos de luxo que você pode aplicar gastando centavos.',
  isBonus: true
}];
export function FeaturesSection() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="features" className="py-12 md:py-24 bg-gradient-to-br from-stone-50 to-amber-50" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-65">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-stone-900 mb-4 md:mb-6" data-id="element-66">
            O Que Você Vai Receber
          </h2>
          <p className="text-lg md:text-xl text-stone-600 max-w-3xl mx-auto" data-id="element-67">
            Um sistema completo, passo a passo, para criar lembrancinhas que
            parecem caras gastando pouco
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-68">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.5
        }} className={`relative ${feature.isBonus ? 'bg-gradient-to-br from-amber-50 to-yellow-50 border-2 border-amber-300' : 'bg-white'} p-5 md:p-8 rounded-xl md:rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300`} data-id="element-69">
              {feature.isBonus && <div className="absolute -top-3 -right-3 bg-gradient-to-r from-amber-500 to-yellow-500 text-white px-3 py-1 rounded-full shadow-lg flex items-center gap-1.5" data-id="element-70">
                  <Gift className="w-3 h-3" data-id="element-71" />
                  <span className="text-xs font-bold uppercase tracking-wider" data-id="element-72">
                    Bônus
                  </span>
                </div>}
              <div className="flex items-start gap-4 md:gap-5" data-id="element-73">
                <div className={`${feature.isBonus ? 'bg-gradient-to-br from-amber-200 to-yellow-200' : 'bg-gradient-to-br from-amber-100 to-yellow-100'} p-3 md:p-4 rounded-xl flex-shrink-0`} data-id="element-74">
                  <feature.icon className={`w-5 h-5 md:w-7 md:h-7 ${feature.isBonus ? 'text-amber-700' : 'text-amber-600'}`} data-id="element-75" />
                </div>
                <div data-id="element-76">
                  <h3 className="text-lg md:text-xl font-bold text-stone-900 mb-2 md:mb-3" data-id="element-77">
                    {feature.title}
                  </h3>
                  <p className="text-sm md:text-base text-stone-600 leading-relaxed" data-id="element-78">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} className="mt-10 md:mt-16 bg-gradient-to-r from-amber-500 to-yellow-600 p-6 md:p-10 rounded-2xl md:rounded-3xl shadow-2xl text-white text-center" data-id="element-79">
          <h3 className="text-xl md:text-3xl font-bold mb-3 md:mb-4" data-id="element-80">
            Tudo isso em um único guia completo
          </h3>
          <p className="text-base md:text-xl opacity-95 max-w-2xl mx-auto" data-id="element-81">
            Você não precisa pesquisar mais nada. Não precisa ficar perdida no
            Pinterest. Tudo que você precisa está aqui.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8,
        duration: 0.6
      }} className="mt-8 md:mt-12 text-center" data-id="element-82">
          <button onClick={scrollToPricing} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-bold text-lg md:text-xl px-8 py-4 md:px-12 md:py-5 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-green-500/50" data-id="element-83">
            Garantir essa oportunidade agora!
          </button>
        </motion.div>
      </div>
    </section>;
}